import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerInformeConservacion = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Informe/ObtenerInformesConservacion",values,customConfig);

        return resultado

    } catch (error) {
        console.log(error);
    
    }

}
export { ObtenerInformeConservacion };